import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { CameraLifetime } from '@vectronic/util';
import { Subscription } from 'rxjs';
import { CameraLifetimeService } from '../../../services/camera-lifetime.service';
import { CameraScheduleService } from '../../../services/camera-schedule.service';
@Component({
  selector: 'rc-camera-lifetime',
  templateUrl: './camera-lifetime.component.html',
  styleUrls: ['./camera-lifetime.component.scss'],
  imports: [MatCard, MatCardTitle, MatDivider, MatCardContent, DatePipe],
})
export class CameraLifetimeComponent implements OnInit, OnDestroy {
  private cameraScheduleService = inject(CameraScheduleService);
  private cameraLifetimeService = inject(CameraLifetimeService);

  lifetimeSubscription: Subscription;
  lifeTime: CameraLifetime;
  lengthOfRule: number;

  ngOnInit() {
    this.lifetimeSubscription = this.cameraScheduleService.rules$.subscribe((rules) => {
      const rulesArray = Object.values(rules);
      this.lengthOfRule = rulesArray?.length;
      const rule = rulesArray?.[0];
      if (rule?.cameraScheduleRuleType === 'VIDEO') {
        this.lifeTime = this.cameraLifetimeService.getLifetimeVideo(rule);
      } else if (rule?.cameraScheduleRuleType === 'PICTURE') {
        this.lifeTime = this.cameraLifetimeService.getLifetimePhoto(rule);
      } else {
        this.lifeTime = undefined;
      }
    });
  }

  ngOnDestroy() {
    this.lifetimeSubscription?.unsubscribe();
  }
}
